import React, { useEffect, useRef } from 'react';
import QuotationImportPanel from './QuotationImportPanel';

export default function QuotationImportWorkspace(props) {
  const dialog = useRef(null), panel = useRef(null);
  useEffect(() => {
    const element = dialog.current;
    const previousFocus = document.activeElement;
    if (element.showModal) element.showModal();
    else element.setAttribute('open', '');
    return () => { if (element.close) element.close(); previousFocus?.focus?.(); };
  }, []);
  return <dialog ref={dialog} className="quotation-workspace" aria-label={`Conferência ${props.request.identifier}`} onCancel={(event) => { event.preventDefault(); panel.current?.requestClose(); }}>
    <QuotationImportPanel ref={panel} {...props} />
  </dialog>;
}
